import { Post } from "../api/apiUtils";
import { OfflineWorkPacketLog } from "../models/OfflineDataHistory";
import {
  WorkPacketDocument,
  WorkPacketValue,
  WorkPacketValue2,
  WorkPacketValuesModel
} from "../models/WorkPacket";

export class WorkPacketService {
  public async saveValues(payload: any) {
    const response = await Post(
      `api/workpacket/${payload.lineHandlingNo}/${payload.workPacketId}/values`,
      JSON.stringify(payload)
    );
    if (response.ok) {
      const result = await response.json();
      //console.log("SAVE RESULT", result);
      return result;
    } else if (response.status === 399) {
    } else {
    }
  }

  public async executeActionAsync(
    payload: any,
    offlineExecute: (() => void) | undefined = undefined
  ): Promise<WorkPacketValuesModel> {
    const response = await Post(
      `api/workpacket/${payload.lineHandlingNo}/${payload.workPacketId}/values`,
      JSON.stringify(payload)
    );
    if (response.ok) {
      const result = (await response.json()) as WorkPacketValuesModel;
      return result;
    } else if (response.status === 399) {
      // console.log("Offline Execute", result);
      if (offlineExecute) offlineExecute();
      return {
        documents: [],
        values: []
      };
      // return result;
    } else {
      let errorMessage = "Unexpected error occurs. Please try again.";
      try {
        const message = await response.json();
        if (message && message.message) errorMessage = message.message;
      } catch (ex) {}
      throw new Error(errorMessage);
    }
  }

  public async offlineExecuteAsync(payload: any, offlineExecute?: () => void) {
    console.log("Offline Execute");
    if (offlineExecute) offlineExecute();
    return {
      documents: [],
      values: []
    };
  }

  public async executeActionsAsync(
    workPacketData: OfflineWorkPacketLog
  ): Promise<WorkPacketValuesModel | undefined> {
    const response = await Post(
      `api/workpacket/${workPacketData.lineHandlingNo}/${workPacketData.workPacketId}/values`,
      JSON.stringify(workPacketData)
    );
    if (response.ok) {
      const result = (await response.json()) as WorkPacketValuesModel;
      return result;
    }

    return undefined;
  }

  public static async saveWorkPacketDataLogsAsync(
    lineHandlingNo: string,
    workPacketValues: WorkPacketValue[],
    workPacketDocuments: WorkPacketDocument[]
  ) {
    const cache = await caches.open("sof");
    const url = `/api/workpacket/${lineHandlingNo.toUpperCase()}/values`;
    cache.delete(url);
    const payload = {
      documents: workPacketDocuments,
      values: workPacketValues
    } as WorkPacketValuesModel;
    cache.put(url, new Response(JSON.stringify(payload)));
  }
}
